export const applyDrag = (arr, dragResult) => {
  const { removedIndex, addedIndex, payload } = dragResult;
  if (removedIndex === null && addedIndex === null) return arr;

  let itemToAdd = payload;

  if (removedIndex !== null) {
    itemToAdd = arr.splice(removedIndex, 1)[0];
  }

  if (addedIndex !== null) {
    arr.splice(addedIndex, 0, itemToAdd);
  }

  return arr;
};

export function difference(setA, setB) {
  let setC = new Set(setA);

  for (let v of setB) {
    setC.delete(v);
  }

  return setC;
}

export function generateId(length = 16) {
  let charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let retVal = "";

  for (let i = 0, n = charset.length; i < length; ++i) {
    retVal += charset.charAt(Math.floor(Math.random() * n));
  }
  return retVal;
}

export function baseURL() {
  if (location.hostname === "goleko.com") {
    return "https://goleko.com";
  }
  if (location.hostname === "0.goleko.com") {
    return "https://0api.goleko.com";
  }
  if (location.hostname === "1.goleko.com" || location.hostname === "localhost") {
    return "https://1api.goleko.com";
  }
  if (location.hostname === "2.goleko.com") {
    return "https://2.goleko.com";
  }
  return "https://goleko.com";
}

export function getTagsAsArray(task, usersMap, tagMap) {
  let tags = []
  if (typeof task.tags == "string") {
    tags = task.tags
      .split("|")
      .filter((tag) => tag.trim() !== "")
      .map((tag) => {
        let t = tag.split(":");
        return {
          tagType: t[0],
          id: Number(t[1]),
        };
      })
      .filter((tag) => tag.id)
      .map((tag) => {
        if (tag.tagType == "user") {
          return {
            tagType: tag.tagType,
            ...usersMap.get(tag.id),
          };
        }
        if (tag.tagType == "tag") {
          return {
            tagType: tag.tagType,
            ...tagMap.get(tag.id),
          };
        }
      });
  } else if (typeof task.tags == "array" || (typeof task.tags == "object" && task.tags && typeof task.tags[0] == "string")) {
    tags = task.tags
      .map((tag) => {
        let t = tag.split(":");
        return {
          tagType: t[0],
          id: Number(t[1]),
        };
      })
      .filter((tag) => tag.id)
      .map((tag) => {
        if (tag.tagType == "user") {
          return {
            tagType: tag.tagType,
            ...usersMap.get(tag.id),
          };
        }
        if (tag.tagType == "tag") {
          return {
            tagType: tag.tagType,
            ...tagMap.get(tag.id),
          };
        }
      });
  } else if (typeof task.tags == "object" && task.tags && typeof task.tags[0] == "object") {
    tags = task.tags;
  } else {
    tags = [];
  }

  return tags
}
